// extracted by mini-css-extract-plugin
export default {"container":"Promo_container__-K+o7","title":"Promo_title__Jev48","text":"Promo_text__Ay33H","link":"Promo_link__BavW7"};